import React from "react";
import { Switch, Route, Redirect } from "react-router-dom";

import { Layout } from "./layout/Layout";
import ForgotPassword from "./module/auth/ForgotPassword";
// PAGES
import Login from "./module/auth/Login";
import BiReport from "./module/bi-report/View";
import Dashboard from "./module/dashboard/View";
import Document from "./module/document/View";
import KForm from "./module/k-form/View";
import MerchandicerView from "./module/merchandiser/Page";
import PhotoReviewPage from "./module/photo-review/View";
import { PointsResourceList, PointsResourcePage } from "./module/points";
import Profile from "./module/profile/Edit";
import RouteList from "./module/route/List";
import RouteView from "./module/route/Page";
import TaskReviewList from "./module/task-review/View";
import { TaskList } from "./module/task/List";
import TaskPage from "./module/task/Page";
import TasksImport from "./module/tasks-import/component";
import VisitList from "./module/visit/List";
import VisitView from "./module/visit/View";

import { User } from "./util/permission";
import { getStore } from "./util/redux/store";

const PrivateRoute = ({ component: Component, ...rest }) => {
  let me = getStore().getState().me;

  return <Route {...rest} render={props => (me ? <Component {...props} {...rest} /> : <Redirect to="/login" />)} />;
};

const AppRouter = () => {
  return (
    <Switch>
      <Route exact path="/login" component={Login} />
      <Route exact path="/forgot-password" component={ForgotPassword} />

      <Layout>
        <PrivateRoute exact path="/">
          <Redirect to="/merchandiser" />
        </PrivateRoute>
        <PrivateRoute exact path="/dashboard" component={User(Dashboard)} />
        <PrivateRoute exact path="/profile" component={User(Profile)} />

        {/*MERCHANDISER*/}
        <PrivateRoute exact path="/merchandiser" component={User(PointsResourceList("merchandisers"))} />
        <PrivateRoute exact path="/merchandiser/:id" component={User(MerchandicerView)} />

        {/*TASK*/}
        <PrivateRoute exact path="/task" component={User(TaskList)} />

        <PrivateRoute exact path="/task/new/:type" component={User(TaskPage)} />
        <PrivateRoute exact path="/task/:id" component={User(TaskPage)} />
        <PrivateRoute exact path="/task/:id/edit" component={User(TaskPage)} />
        <PrivateRoute exact path="/task/:id/view" component={User(TaskPage)} />

        {/*  TASK REVIEW */}
        <PrivateRoute exact path="/task-review" component={User(TaskReviewList)} />

        {/*  TASKS IMPORT */}
        <PrivateRoute exact path="/tasks-import" component={User(TasksImport)} />
        <PrivateRoute exact path="/tasks-import/:id" component={User(TasksImport)} />

        {/*  PHOTO REVIEW */}
        <PrivateRoute path="/photo-review" component={User(PhotoReviewPage)} />
        {/*<PrivateRoute exact path="/photo-review/:id" component={User(PhotoReviewPage)} />*/}
        {/*<PrivateRoute exact path="/photo-review/:id/edit" component={User(PhotoReviewPage)} />*/}
        {/*<PrivateRoute exact path="/photo-review/:id/view" component={User(PhotoReviewPage)} />*/}

        {/* DOCUMENTS */}
        <PrivateRoute exact path="/document" component={User(Document)} />

        {/* KAM FORMS */}
        <PrivateRoute exact path="/k-form" component={User(KForm)} />

        {/* BI-REPORT */}
        <PrivateRoute exact path="/bi-report" component={User(BiReport)} />

        {/*ROUTE*/}
        <PrivateRoute exact path="/route" component={User(RouteList)} />
        <PrivateRoute exact path="/route/:id" component={User(RouteView)} />

        {/*VISIT */}
        <PrivateRoute exact path="/visit" component={User(VisitList)} />
        <PrivateRoute exact path="/visit/:id" component={User(VisitView)} />

        {/* POINTS ADMIN */}
        <PrivateRoute exact path="/points" component={User(PointsResourceList("points"))} />
        <PrivateRoute exact path="/points/:id" component={User(PointsResourcePage("points"))} />
        <PrivateRoute exact path="/networks" component={User(PointsResourceList("networks"))} />
        <PrivateRoute exact path="/networks/:id" component={User(PointsResourcePage("networks"))} />
        <PrivateRoute exact path="/categories" component={User(PointsResourceList("categories"))} />
        <PrivateRoute exact path="/categories/:id" component={User(PointsResourcePage("categories"))} />
        <PrivateRoute exact path="/countries" component={User(PointsResourceList("countries"))} />
        <PrivateRoute exact path="/countries/:id" component={User(PointsResourcePage("countries"))} />
        <PrivateRoute exact path="/counties" component={User(PointsResourceList("counties"))} />
        <PrivateRoute exact path="/counties/:id" component={User(PointsResourcePage("counties"))} />
        <PrivateRoute exact path="/localities" component={User(PointsResourceList("localities"))} />
        <PrivateRoute exact path="/localities/:id" component={User(PointsResourcePage("localities"))} />
        <PrivateRoute exact path="/point_groups" component={User(PointsResourceList("point_groups"))} />
        <PrivateRoute exact path="/point_groups/:id" component={User(PointsResourcePage("point_groups"))} />

        {/* Legacy /point aliases -> new points-admin, so existing deep links (task/visit/review tables) keep working */}
        <PrivateRoute exact path="/point" component={User(PointsResourceList("points"))} />
        <PrivateRoute exact path="/point/:id" component={User(PointsResourcePage("points"))} />

        {/* PERSONNEL MANAGEMENT */}
        <PrivateRoute exact path="/supervisors" component={User(PointsResourceList("supervisors"))} />
        <PrivateRoute exact path="/supervisors/:id" component={User(PointsResourcePage("supervisors"))} />
      </Layout>
    </Switch>
  );
};

export default AppRouter;